export default {
	HeaderTitle: 'Quản lý tài nguyên',
	PackageUse: 'Gói đang sử dụng',
	InvoiceUsePackage: 'Hóa đơn được sử dụng',
	Invoice: 'Hóa đơn',
	UseTo: 'Hóa đơn dùng đến ',
	InfoInvoice: 'Thông tin hóa đơn lũy kế',
	TotalBought: 'Tổng hóa đơn đã mua: ',
	TotalUsed: 'Tổng hóa đơn đã sử dụng: ',
	TotalStillUse: 'Tổng hóa đơn còn được sử dụng: ',
	HistoryResource: 'Lịch sử cấp tài nguyên',
	OrderManager: 'Quản lý đơn hàng',
	Resource: 'Tài nguyên',
	OrderNotPayment: 'Đơn hàng chưa được thanh toán',
	OrderNewBuy: 'Mua đơn hàng mới',
	ConfirmOrder: 'Xác nhận đơn hàng',
	HasCodeNew: 'Tôi đã có mã kích hoạt mới',
	UsedUpInvoice: 'Hóa đơn của bạn đã hết',
	Extension: 'Gia hạn',
	PayNow: 'Mua ngay',
	PayAdd: 'Mua thêm',
	PurchaseInvoice: 'Hóa đơn đã mua',
	Used: 'Đã sử dụng',
	NotUsed: 'Chưa sử dụng',
	ExtensionNow: 'Gia hạn ngay',
	ConfirmPaymentOrder: 'Xác nhận thanh toán',
	ContentTransaction: 'Nội dung chuyển tiền',
	AttachFolder: 'Thêm tệp đính kèm',
	Cancel: 'Hủy bỏ',
	ExpiredComingdDate: 'Thời hạn sử dụng của bạn sắp hết',
	ExpiredDate: 'Thời hạn sử dụng của bạn đã hết',
	ExpiredCommingInvoice: 'Hóa đơn sử dụng của bạn sắp hết',
	ExpiredInvoice: 'Hóa đơn sử dụng của bạn đã hết',
	ExpiredCommingInvoiceDate: 'Thời hạn và hóa đơn sử dụng của bạn sắp hết',
	ExpiredInvoiceDate: 'Thời hạn và hóa đơn sử dụng của bạn đã hết',
	AllowUsed: 'Tài nguyên đã bị thu hồi',
	LicenseCommingDate: 'Tài nguyên của bạn sắp hết',
	PaymentOrderUsing: 'Bạn cần Gia hạn/Mua thêm tài nguyên để tiếp tục sử dụng phần mềm',
	LicenseExpiredDate: 'Tài nguyên của bạn đã hết',

	//Bổ sung
	ConfirmPayment: {
		AlertFillCorrectContent:
			'Quý khách vui lòng nhập chính xác nội dung chuyển tiền ghi trong Ủy nhiệm chi và đính kèm hình ảnh Ủy nhiệm chi để MISA xác định đã thanh toán',
		ImageConfirm: 'Hình ảnh chứng từ chuyển tiền, ủy nhiệm chi,...',
		DragFileOrClick: 'Kéo và thả tệp vào đây hoặc nhấn để',
		SelectFile: 'Chọn tệp',
		FromComputer: 'Từ máy tính',
		AllowFile: 'Chấp nhận file jpg, png, jpeg dung lượng tối đa 5MB',
		ConfirmPay: 'Xác nhận thanh toán',
		ConfirmPaymentAccess: 'Xác nhận thanh toán đơn hàng thành công'
	},
	Expried: {
		InvoiceOver: 'Hóa đơn của bạn đã hết',
		MessageResourceOver: {
			FirstText: 'Tài nguyên của bạn hết hạn ngày',
			SecondText: 'thực hiện gia hạn',
			EndText: 'thêm thời gian để tiếp tục xử lý hóa đơn'
		},
		AlertBuyMoreInvoice: {
			FirstText: 'Vui lòng mua thêm hóa đơn để tiếp tục sử dụng',
			EndText: 'dịch vụ xử lý hóa đơn điện tử'
		},
		BuyNow: 'Mua ngay'
	},
	OrderExistWarning: {
		DidNotPayment: 'Chưa thanh toán',
		AlertHaveOtherOrderToBuy: {
			FirstText: 'Bạn đang có đơn hàng',
			SecondText: 'chưa thanh toán',
			ThirdText: 'Vui lòng thanh toán hoặc hủy đơn hàng trên trước khi mua đơn hàng mới',
			FourthText: 'Bạn có thực sự muốn hủy đơn hàng số',
			EndText: 'để mua đơn hàng mới không?'
		},
		AlertHaveOtherOrderToActive: {
			FirstText: 'Bạn đang có đơn hàng',
			SecondText: 'chưa thanh toán',
			ThirdText: 'Vui lòng thanh toán hoặc hủy đơn hàng trên trước khi kích hoạt đơn hàng mới',
			FourthText: 'Bạn có thực sự muốn hủy đơn hàng số',
			EndText: 'để kích hoạt đơn hàng mới không?'
		}
	},
	//Bổ sung
	OrderManagerPage: {
		OrderNo: 'Số đơn hàng',
		OrderDate: 'Ngày đặt hàng',
		TotalAmount: 'Số tiền',
		PaymentMethod: 'Phương thức thanh toán',
		PaymentStatus: 'Tình trạng thanh toán',
		Paid: 'Đã thanh toán',
		CancelPayment: 'Đã hủy đơn hàng'
	},
	PaymentDueWarning: {
		AlertActiveTaxCode: 'Bạn đã kích hoạt MST {taxCode} vào ngày {startDate} và được sử dụng',
		ExpireDate: 'MISA meInvoice - Xử lý hóa đơn đến ngày {expiredDate}',
		AlertNeedPaymentToUseAll: 'Để toàn quyền sử dụng dịch vụ, bạn cần thanh toán cho MISA đơn hàng số',
		OutOfDatePayment: 'Quá hạn thanh toán đơn hàng',
		OutOfDateTryUseResource: 'Tài nguyên dùng thử của Quý khách đã hết hạn vào ngày',
		PleasePayment: 'Vui lòng thanh toán để tiếp tục sử dụng.'
	},
	ResourceHistory: {
		StartDate: 'Ngày cấp',
		ExpiredDate: 'Ngày hết hạn',
		NumberOfInvoice: 'Số hóa đơn',
		NumberOfInvoiceSum: 'Số lượng lũy kế',
		Description: 'Mô tả',
		InUse: 'Đang sử dụng',
		Used: 'Đã sử dụng'
	},
	Resources: {
		OrderNo: 'Tài nguyên mua đơn hàng số',
		PendingAllow: 'đang trạng thái chờ duyệt',
		ShowOrder: 'Xem đơn hàng',
		Active: 'Kích hoạt',
		BuyNow: 'Mua ngay',
		Extend: 'Gia hạn',
		BuyMore: 'Mua thêm'
	},
	UsedUpWarning: {
		AlertResourceRunningOutSoon: {
			FirstText: 'Tài nguyên sử dụng của Quý khách chỉ còn thời hạn',
			SecondText: 'ngày với',
			ThirdText: `Hóa đơn còn lại.
			Vui lòng Gia hạn/Mua thêm để quá trình sử dụng không bị gián đoạn.`
		},
		AlertOutOfResource: 'Tài nguyên sử dụng của Quý khách đã hết. Vui lòng Gia hạn/Mua thêm để tiếp tục sử dụng.',
		ALertTimeRunningOutSoon: {
			FirstText: 'Thời gian sử dụng của Quý khách chỉ còn',
			SecondText: 'ngày',
			ThirdText: `Vui lòng Gia hạn để quá trình sử dụng không bị gián đoạn.`
		},
		AlertTimeOut: 'Thời gian sử dụng của Quý khách đã hết. Vui lòng Gia hạn để tiếp tục sử dụng.',
		AlertOrderRunningOutSoon: {
			FirstText: 'Số lượng hóa đơn được phép sử dụng của Quý khách chỉ còn',
			SecondText: `hóa đơn. Vui lòng Mua thêm để quá trình sử dụng không bị gián đoạn.`
		},
		AlertOutOfOrder:
			'Số lượng hóa đơn còn được phép sử dụng của Quý khách đã hết. Vui lòng Mua thêm để tiếp tục sử dụng.',
		AlertTrial: 'Bạn đã trải nghiệm hết tài nguyên dùng thử. Thực hiện Mua ngay để tiếp tục sử dụng'
	},
	WarningLicense: {
		Expired: "Thời gian sử dụng của quý khách đã hết.",
		ExpiredTrial: "Thời gian dùng thử của quý khách đã hết.",
		OutOfQuantity: "Số lượng hóa đơn của quý khách đã hết.",
		ExpiredAndQuantity: "Thời gian sử dụng và số lượng hóa đơn của quý khách đã hết.",
		ExpiredAndQuantityTrial: "Thời gian và số lượng hóa đơn dùng thử của quý khách đã hết.",
		Please: "Vui lòng",
		Extend: "gia hạn",
		BuyMore: "mua thêm",
		WarningInterruption: "để không bị gián đoạn công việc.",
		Update: "Vui lòng nâng cấp phiên bản chính thức để không bị gián đoạn công việc."
	}
};
